export default {
	title: "Lucky Wheels",
	Lucky: "Lucky",
	wheels: "Lottery",
	winningrecord: "Winning Record",
	ActivityRules: "Activity Rules",
	ActivityRulesContent: "For more information about the lucky draw, please contact our customer service.",
	award: {
		title: "Congratulations on winning!",
		btn: "Receive award"
	},
	noticeItem: "{0} acquired {1}",
	lotteryDraws: "{0} lottery draws",
	noAvailableTimes: "Insufficient available attempts. Please contact customer service.",
	noOpen: "Not yet open",
	noWinning: "make persistent efforts",
	ViewALlPrizes: "View ALl Prizes",
	myPrizes: "My Prizes",
	share: "Share with a friend"
};
